import axios from "axios"
import { history } from "../../../history"
import API from '../../../services/api'

export const getData = (params, comState) => (dispatch) => new Promise(function (resolve, reject) {
  API({
    url: 'organization/list',
    method: 'POST',
    params: params
  }).then(response => {
    let sortedIndex = [
      comState.currentPage == 1 ? (comState.currentPage) : ((comState.rowsPerPage * comState.currentPage) - comState.rowsPerPage) + 1,
      comState.currentPage == 1 ?
      (response.data.query.total_count < (comState.rowsPerPage * comState.currentPage)) ? response.data.query.total_count : comState.rowsPerPage :
      ((response.data.query.total_count < (comState.rowsPerPage * comState.currentPage)) ? response.data.query.total_count : (comState.rowsPerPage * comState.currentPage))
    ]

    dispatch({
      type: "GET_DATA",
      data: response.data,
      totalPages: response.data.query ? Math.ceil(response.data.query['total_count'] / comState.rowsPerPage) : 0,
      totalRecords: response.data.query.total_count,
      currentPage: comState.currentPage,
      rowsPerPage: comState.rowsPerPage,
      sortIndex: sortedIndex,
      params
    })
    resolve(response);
  }).catch(err => {
    reject(err);
  })
});

export const getCurrentOrganization = (params) => (dispatch) => new Promise(function (resolve, reject) {
  console.log('getCurrentOrganization')
  API.post('organization/view', params).then(response => {
    dispatch({
      type: "SET_CURRENT_ORG",
      data: response.data
    })
    resolve(response);
  }).catch(err => {
    reject(err);
  })
});

export const updateOrganizationInfo = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post('/organization/update', params).then(response => {
    // dispatch({ type: "SET_CURRENT_ORG", data: response.data })
    resolve(response);
  }).catch(err => {
    reject(err);
  })
});

export const getLocations = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post(`/location/list?limit=${params.limit ? params.limit: 10 }&offset=${params.offset ? params.offset : 0}&sort_by=${params.short_by}&sort_type=${params.sort_type}`, {
    org_public_id: params.org_public_id
  }).then(response => {
    dispatch({
      type: "SET_CURRENT_ORG_LOCATIONS",
      data: response.data.loc
    })
    dispatch({
      type: "SET_TOTAL_ORG_LOCATIONS",
      data: response.data.total_count
    })
    resolve(response);
  }).catch(err => {
    reject(err);
  })
});

export const createLocations = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post(`/location/create`, params).then(response => {
    dispatch(getLocations({
      org_public_id: params.org_public_id
    }))
    resolve(response);
  }).catch(err => {
    reject(err);
  })
});

export const updateLocations = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post(`/location/update`, params).then(response => {
    dispatch(getLocations({
      org_public_id: params.org_public_id
    }))
    resolve(response);
  }).catch(err => {
    reject(err);
  })
});

export const deleteLocation = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post(`/location/delete`, params).then(response => {
    dispatch(getLocations({
      org_public_id: params.org_public_id
    }))
    resolve(response);
  }).catch(err => {
    reject(err);
  })
});

export const getDistributors = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post(`/distributor/list?limit=${params.limit ? params.limit: 10 }&offset=${params.offset ? params.offset : 0}&sort_by=${params.short_by}&sort_type=${params.sort_type}`, params ).then(res => {
    dispatch({
      type: "SET_CURRENT_ORG_DISTRIBUTORS",
      data: res.data.dist
    })
    dispatch({
      type: "SET_TOTAL_ORG_DISTRIBUTORS",
      data: res.data.total_count
    })
    resolve(res);
  }).catch(err => {
    reject(err);
  });
});

export const createDistributor = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post(`/distributor/create`, params ).then(res => {
    dispatch(getDistributors({
      org_public_id: params.org_public_id
    }))
    resolve(res);
  }).catch(err => {
    reject(err);
  });
});

export const updateDistributor = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post(`/distributor/update`, params ).then(res => {
    dispatch(getDistributors({
      org_public_id: params.org_public_id
    }))
    resolve(res);
  }).catch(err => {
    reject(err);
  });
});

export const deleteDistributor = (params) => (dispatch) => new Promise(function (resolve, reject) {
  console.log(params)
  API.post(`/distributor/delete`, params).then(response => {
    dispatch(getDistributors({
      org_public_id: params.org_public_id
    }))
    resolve(response);
  }).catch(err => {
    reject(err);
  })
});

export const getUsers = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post(`/organization/user/list?limit=${params.limit ? params.limit: 10 }&offset=${params.offset ? params.offset : 0}&sort_by=${params.short_by}&sort_type=${params.sort_type}`, params ).then(res => {
    dispatch({
      type: "SET_CURRENT_ORG_USERS",
      data: res.data.users
    })
    dispatch({
      type: "SET_TOTAL_ORG_USERS",
      data: res.data.query.total_count
    })
    resolve(res);
  }).catch(err => {
    reject(err);
  });
});

export const createUser = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post(`/organization/user/registration`, params ).then(res => {
    dispatch(getUsers({
      org_public_id: params.org_public_id
    }))
    resolve(res);
  }).catch(err => {
    reject(err);
  });
});

export const updateUser = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post(`/organization/user/update`, params ).then(res => {
    dispatch(getUsers({
      org_public_id: params.org_public_id
    }))
    resolve(res);
  }).catch(err => {
    reject(err);
  });
});

export const updateUserPassword = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post(`/admin/user/update-password`, params ).then(res => {
    dispatch(getUsers({
      org_public_id: params.org_public_id
    }))
    resolve(res);
  }).catch(err => {
    reject(err);
  });
});

export const deleteUser = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post(`/organization/user/delete`, params).then(response => {
    dispatch(getUsers({
      org_public_id: params.org_public_id
    }))
    resolve(response);
  }).catch(err => {
    reject(err);
  })
});


/**
 * Products tab
 */
export const getProducts = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post(`/forecast/product-list?limit=${params.limit ? params.limit: 10 }&offset=${params.offset ? params.offset : 0}&sort_by=${params.short_by}&sort_type=${params.sort_type}`, params ).then(res => {
    dispatch({
      type: "SET_CURRENT_ORG_PRODUCTS",
      data: res.data.productList
    })
    dispatch({
      type: "SET_TOTAL_ORG_PRODUCTS",
      data: res.data.total_count
    })
    resolve(res);
  }).catch(err => {
    reject(err);
  });
});
/**
 * Products tab end
 */


export const getSubscriptionLists = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post(`/subscription/list`).then(response => {
    dispatch({
      type: "SET_SUBSCRIPTION_LIST",
      data: response.data.SubscriptionPlan
    })
    resolve(response);
  }).catch(err => {
    reject(err);
  })
});

export const updateOrganizationSubscription = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post(`/organization/subscription-assign`, params).then(response => {
    dispatch(getCurrentOrganization({
      org_public_id: params.org_public_id
    }))
    resolve(response);
  }).catch(err => {
    reject(err);
  })
});

export const getOrganizationSettings = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post(`/org/setting/list`, params ).then(res => {
    dispatch({
      type: "SET_ORG_SETTINGS",
      data: res.data 
    })
    resolve(res);
  }).catch(err => {
    reject(err);
  });
});

export const organizationSettingUpdate = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post(`/org/setting/update`, params ).then(res => {
    dispatch(getOrganizationSettings(params))
    resolve(res);
  }).catch(err => {
    reject(err);
  });
});

export const getOrganizationTDForcast = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post(`/forecast/td-forecast-list`, params, {
    params: params
  }).then(res => {
    dispatch({
      type: "SET_ORG_TD_FORCAST",
      data: res.data
    })
    resolve(res);
  }).catch(err => {
    reject(err);
  });
});

export const getOrganizationTDForcastListForImport = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post(`/forecast/td-actual-list`, params, {
    params: params
  }).then(res => {
    dispatch({
      type: "SET_ORG_TD_FORCAST_LIST_IMPORT",
      data: res.data
    })
    resolve(res);
  }).catch(err => {
    reject(err);
  });
});

export const getOrganizationTDForcastWeeks = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post(`/forecast/td-week-id`, params, {
    params: params
  }).then(res => {
    dispatch({
      type: "SET_ORG_TD_FORCAST_WEEKS",
      data: res.data
    })
    resolve(res);
  }).catch(err => {
    reject(err);
  });
});

export const getOrganizationBUForcast = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post(`/forecast/bu-forecast-list`, params, {
    params: params
  }).then(res => {
    dispatch({
      type: "SET_ORG_BU_FORCAST",
      data: res.data
    })
    resolve(res);
  }).catch(err => {
    reject(err);
  });
});

export const getOrganizationBUForcastListForImport = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post(`/forecast/bu-actual-list`, params, {
    params: params
  }).then(res => {
    dispatch({
      type: "SET_ORG_BU_FORCAST_LIST_IMPORT",
      data: res.data
    })
    resolve(res);
  }).catch(err => {
    reject(err);
  });
});

export const getOrganizationBUForcastWeeks = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post(`/forecast/bu-week-id`, params, {
    params: params
  }).then(res => {
    dispatch({
      type: "SET_ORG_BU_FORCAST_WEEKS",
      data: res.data
    })
    resolve(res);
  }).catch(err => {
    reject(err);
  });
});

export const getOrganizationROForcast = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post(`/forecast/reorder-list`, params, {
    params: params
  }).then(res => {
    dispatch({
      type: "SET_ORG_RO_FORCAST",
      data: res.data
    })
    resolve(res);
  }).catch(err => {
    reject(err);
  });
});

// logs
export const getOrganizationLogs = (params) => (dispatch) => new Promise(function (resolve, reject) {
  API.post(`/log/list`, params, {
    params: params
  }).then(res => {
    dispatch({
      type: "SET_ORG_LOGS",
      data: res.data
    })
    resolve(res);
  }).catch(err => {
    reject(err);
  });
});
// logs end








export const changeFilter = (path, filter) => {
  return dispatch => {
    dispatch({ type: "CHANGE_FILTER", filter })
    history.push(`${path}/${filter}`)
    // dispatch(getOrganizationInformation({ filter }))
  }
}

export const getInitialData = (params) => {
  return async dispatch => {
    await API({
      url: 'organization/list',
      method: 'POST',
      params: params
    }).then(response => {
      dispatch({
        type: "GET_ALL_DATA",
        data: response.data.org
      })
    })
  }
}

export const getMasterData = (params) => {
  return async dispatch => {
    await API({
      url: '/master/all-data',
      method: 'POST',
    }).then(response => {
      dispatch({
        type: "GET_ALL_MASTER_DATA",
        data: response.data
      })
    })
  }
}

export const filterData = valueParams => {

  return async dispatch => {
    await API({
      url: 'organization/list',
      method: 'POST',
      params: valueParams
    }).then(response => {
      // dispatch({
      //   type: "GET_DATA",
      //   data: response.data.org?  response.data.org.map( data=>Object.assign(data, { subscription_plan_name: data.subscription_plan_name ? data.subscription_plan_name : ''})) : [],
      //   totalPages: response.data.org ? Math.ceil(response.data.org.length / 5) : 0,
      //   valueParams
      // })

      let value = response.data.org ? response.data.org.map(data => Object.assign(data, {
        subscription_plan_name: data.subscription_plan_name ? data.subscription_plan_name : ''
      })) : []
      dispatch({
        type: "CUSTOM_FILTER_DATA",
        value
      })
    })
  }

  // return dispatch => dispatch({ type: "FILTER_DATA", value })
}

export const deleteData = obj => {
  return dispatch => {
    API
      .post("organization/delete", {
        obj
      })
      .then(response => {
        dispatch({
          type: "DELETE_DATA",
          obj
        })
      })
  }
}

export const updateData = obj => {
  return (dispatch, getState) => {
    API
      .post("/organization/update", {
        obj
      })
      .then(response => {
        dispatch({
          type: "UPDATE_DATA",
          obj
        })
      })
  }
}

export const addData = obj => {
  return (dispatch, getState) => {
    let params = getState().dataList.params
    API
      .post("/organization/create", {
        obj
      })
      .then(response => {
        dispatch({
          type: "ADD_DATA",
          obj
        })
        dispatch(getData(params))
      })
  }
}
